<div class="col dashboardTopMenu">

  <div class="btn-group me-3">
    <button type="button" class="btn btn-outline-primary dashboardTopMenuLink" routerLink="/dashboard">
      {{'dashboard' | translate}}
    </button>

    <div class="btn-group" ngbDropdown role="group" aria-label="Button group with nested dropdown">

      <button type="button" class="btn btn-outline-primary dashboardTopMenuLink" [routerLink]="'/delayOrder'">{{
        'delayOrder' | translate }}</button>

    </div>
    <button type="button" class="btn btn-outline-primary dashboardTopMenuLink" [routerLink]="'/workStation'">{{
      'workingStationLive' | translate }}</button>
    <div class="btn-group" ngbDropdown role="group" aria-label="Button group with nested dropdown">
      <button type="button" class="btn btn-outline-primary dashboardTopMenuLink" ngbDropdownToggle>{{ 'reportsAnalytics'
        | translate }}</button>
      <div class="dropdown-menu" ngbDropdownMenu>
        <button ngbDropdownItem [routerLink]="'/NewCustomerRegistration'">{{ 'newCustomerRegistration' | translate
          }}</button>
        <button ngbDropdownItem [routerLink]="'/TopActiveCUstomer'">{{ 'topActiveCustomer' | translate }}</button>
        <button ngbDropdownItem [routerLink]="'/CustomerBehavior'">{{ 'customerBehavior' | translate }}</button>
        <button ngbDropdownItem [routerLink]="'/OrdersOvertime'">{{ 'ordersOverTime' | translate }}</button>
        <button ngbDropdownItem [routerLink]="'/ServicePerformance'">{{ 'servicePerformance' | translate }}</button>
        <button ngbDropdownItem [routerLink]="'/TeamPerformance'">{{ 'teamPerformance' | translate }}</button>
        <!-- <button ngbDropdownItem [routerLink]="'/RDCPrimaryData'">{{ 'rdcPrimaryData' | translate }}</button> -->

      </div>
    </div>
  </div>

</div>